import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { useLocation, useNavigate } from "react-router";
import { useForm, FormProvider } from "react-hook-form";
import {
  getMisc,
  getSpecificSMSCampDetails,
  updateSMSCampaigns,
  updateCampaignProofOfDoc,
} from "../../apiclients/streamsapi_bridge";
import CampaignTypes from "../smsbrand/CampaignTypes";
import SMSCampaignDetails from "../smsbrand/CampaignDetails";
import CampaignAssignNumbers from "../smsbrand/CampaignAssignNumbers";
import { use } from "i18next";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import SaveChanges from "../../components/topviews/saveCancel";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import EditWarning from "../../components/header/EditWarning";
import SampeAIChecksPOPUP from "../smsbrand/SampeAIChecksPOPUP";
import ProofDocuments from "../smsbrand/ProofDocuments";
import CampaignProofDocuments from "./CampaignProofDocuments";

function SMSCampaignRegistration() {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const containerRef2 = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const location = useLocation();
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [campInfo, setcampInfo] = useState(
    location.state ? location.state : {},
  );
  const [useCases, setuseCases] = useState([]);
  const [subUseCases, setsubUseCases] = useState([]);
  const [optinMessage, setoptinMessage] = useState("");
  const [optOutMessage, setoptOutMessage] = useState("");
  const [helpMessage, sethelpMessage] = useState("");
  const [subCasesList, setsubCasesList] = useState([]);
  const [sampleMessages, setsampleMessages] = useState({});
  const [assignedPhoneNumbers, setassignedPhoneNumbers] = useState([]);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [brandMiscInfo, setbrandMiscInfo] = useState({});
  const [sourceNumber, setSourceNumber] = useState([]);
  const [campaignMiscInfo, setcampaignMiscInfo] = useState({});
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const [savedUseCases, setsavedUseCases] = useState([]);
  const [SavedConsent, setSavedConsent] = useState("");
  const [internalError, setInternalError] = useState("");
  const [aiReviewSummary, setaiReviewSummary] = useState(false);
  const [isCampaignEdit, setisCampaignEdit] = useState(true);
  const [campStatus, setcampStatus] = useState("");
  const [campName, setcampName] = useState("");
  const [aiResults, setAiResults] = useState({
    embedded_link: false,
    embedded_phnum: false,
    age_gated: false,
  });

  // Proof Documents state
  const [proofExistFiles, setProofExistFiles] = useState([]);

  // Update defaultValues in useForm initialization
  const formMethods = useForm({
    defaultValues: {
      campaign_details: {
        campaign_name: "",
        embed_link: false,
        embed_phno: false,
        age_content: false,
        usecases: {
          case: [],
          subcase: [],
        },
        camp_desc: {
          desc: "",
          optin_desc: "",
          optout_desc: "",
          help_desc: "",
          msg_flow: "",
          cmp_usage: 1,
          smpl_msgs: [
            { id: 1, msg_txt: "" },
            { id: 2, msg_txt: "" },
          ], // UPDATED: Default 2 sample messages
          consent_msg: [],
          msg_flow_chk: false,
        },
        location_id: 0,
        billing_group_id: 1,
      },
      ph_numbers: {
        add_phnums: [],
        remove_phnums: [],
      },
    },
  });

  const {
    register,
    setValue,
    getValues,
    watch,
    formState: { isDirty, dirtyFields, errors },
    reset,
    handleSubmit,
    setError,
    clearErrors,
  } = formMethods;

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#");
      if (targetValues.length > 1) {
        navigate(targetValues[0], {
          state: { tab: targetValues[1] },
        });
      } else {
        navigate(targetValues[0]);
      }
    }
    setShowWarning(false);
  };

  useEffect(() => {
    if (campInfo.campaignid || rerender) {
      getSpecificCampaign();
      fetchData();
    }
  }, [campInfo, rerender]);

  // Fetch Location & Billing Group dropdown data (same pattern as addUsers.js / SmsCompliance.jsx).
  // Unlike the create flow, we do NOT default to the site's default location here —
  // the campaign's own location_id/billing_group_id is prefilled via getSpecificCampaign()'s reset().
  useEffect(() => {
    async function fetchLocationBillingMisc() {
      try {
        const siteid = JSON.parse(
          sessionStorage.getItem("admin_session"),
        )?.siteid;
        const response = await getMisc(siteid, {
          misc: ["all_locations", "billinggroups"],
        });
        const tdata = await response.json();
        setAllLocations(tdata?.misc?.all_locations ?? []);
        setBillingGroupList(tdata?.misc?.billinggroups ?? []);
      } catch (error) {
        // Location/Billing Group dropdowns simply render empty on failure
      }
    }
    fetchLocationBillingMisc();
  }, []);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["brand_cmpg_mics"] },
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with ID not found`);
      // navigate("/");
    }
    const { cmpNmbers, ...rest } = tdata.misc.brand_cmpg_mics?.cmpgnmisc ?? {};
    setSourceNumber(cmpNmbers ?? []);
    setcampaignMiscInfo(rest ?? {});
  }

  // Update getSpecificCampaign function
  async function getSpecificCampaign() {
    try {
      setIsloading(true);
      const response = await getSpecificSMSCampDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        campInfo.campaignid,
      );
      setTimeout(() => {
        setIsloading(false);
      }, 500);
      const campDetails = await response.json();
      console.log(
        "getSpecific getSpecificCampaign ::: " + JSON.stringify(campDetails),
      );
      setcampStatus(campDetails?.sms_campaigns?.status ?? {});
      setcampName(campDetails?.sms_campaigns?.campaign_name ?? {});
      setassignedPhoneNumbers(
        campDetails?.sms_campaigns?.assigned_phnums ?? [],
      );
      setsavedUseCases(campDetails?.sms_campaigns?.camp_desc?.smpl_msgs ?? []);
      setSavedConsent(typeof campDetails?.sms_campaigns?.camp_desc?.consent_msg === "string" ? campDetails.sms_campaigns.camp_desc.consent_msg : "");
      setProofExistFiles(campDetails?.sms_campaigns?.proof_docs ?? []);
      setisCampaignEdit(campDetails?.sms_campaigns?.isInitiated !== undefined ? campDetails?.sms_campaigns?.isInitiated === 1 ? false : true : true);

      // UPDATED: Ensure sample messages have proper structure with sequential IDs
      const sampleMessages =
        campDetails?.sms_campaigns?.camp_desc?.smpl_msgs ?? [];
      const formattedMessages =
        sampleMessages.length >= 2
          ? sampleMessages.map((msg, idx) => ({
            id: msg.id || idx + 1,
            msg_txt: msg.msg_txt || "",
          }))
          : [
            { id: 1, msg_txt: sampleMessages[0]?.msg_txt || "" },
            { id: 2, msg_txt: sampleMessages[1]?.msg_txt || "" },
          ];

      // Transform API data to match form structure
      const transformedData = {
        campaign_details: {
          campaign_name: campDetails?.sms_campaigns?.campaign_name ?? "",
          embed_link: campDetails?.sms_campaigns?.embed_link ?? false,
          embed_phno: campDetails?.sms_campaigns?.embed_phno ?? false,
          age_content: campDetails?.sms_campaigns?.age_content ?? false,
          brand_name: campDetails?.sms_campaigns?.brand_name ?? "",
          usecases: {
            case: campDetails?.sms_campaigns?.usecases?.subcase ?? [],
            subcase: campDetails?.sms_campaigns?.usecases?.subcase ?? [],
          },
          camp_desc: {
            desc: campDetails?.sms_campaigns?.camp_desc?.desc ?? "",
            optin_desc: campDetails?.sms_campaigns?.camp_desc?.optin_desc ?? "",
            optout_desc:
              campDetails?.sms_campaigns?.camp_desc?.optout_desc ?? "",
            help_desc: campDetails?.sms_campaigns?.camp_desc?.help_desc ?? "",
            msg_flow: campDetails?.sms_campaigns?.camp_desc?.msg_flow ?? "",
            cmp_usage: campDetails?.sms_campaigns?.camp_desc?.cmp_usage ?? 1,
            smpl_msgs: formattedMessages, // UPDATED: Use formatted messages
            consent_msg:
              campDetails?.sms_campaigns?.camp_desc?.consent_msg ?? [],
            msg_flow_chk:
              campDetails?.sms_campaigns?.camp_desc?.msg_flow_chk ?? false,
          },
          location_id: campDetails?.sms_campaigns?.location_id ?? 0,
          billing_group_id: campDetails?.sms_campaigns?.billing_group_id ?? 1,
        },
        ph_numbers: {
          add_phnums: [],
          remove_phnums: [],
        },
      };

      reset(transformedData);
      setRerender(false);
    } catch (error) {
      console.error("Error fetching campaign details:", error);
    }
  }

  function closeSave(e) {
    reset();
  }

  async function handleSaveProofDocs(newFiles = [], deletedIds = []) {
    try {
      const formData = new FormData();
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      );
      formData.append("campaign_id", campInfo.apiCampaignId);

      // Append newly added files
      if (newFiles && newFiles.length > 0) {
        newFiles.forEach((file) => {
          formData.append("proof_docs", file.file, file.name);
        });
      }

      // Append deleted file IDs
      if (deletedIds && deletedIds.length > 0) {
        deletedIds.forEach((id) => {
          formData.append("deletepdfs", id);
        });
      }

      console.log("handleSaveProofDocs FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      setIsloading(true);
      let saverep = await updateCampaignProofOfDoc(formData);
      console.log(
        `response of updateCampaignProofOfDoc :::: ${JSON.stringify(saverep)}`,
      );
      let saverepeMsg = await saverep.json();
      console.log(
        "response of updateCampaignProofOfDoc ::: " +
          JSON.stringify(saverepeMsg),
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);

      if (saverepeMsg.status && saverepeMsg.status === "success") {
        setSuccessMessage(saverepeMsg.message);
        getSpecificCampaign();
        return true;
      }
      return false;
    } catch (error) {
      console.error("handleSaveProofDocs failed:", error);
      setIsloading(false);
      return false;
    }
  }

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave]);

  // Update onSubmit function to ensure proper structure
  const onSubmit =
    (confirm = 0) =>
      async (data) => {
        const modifiedData = {};

        // Step 1: handle everything except smpl_msgs & consent_msg
        const excluded = [
          "campaign_details.camp_desc.smpl_msgs",
          "campaign_details.camp_desc.consent_msg",
        ];
        console.log(
          "extractModifiedFields :::::::::: " + JSON.stringify(dirtyFields),
        );
        const partialData = extractModifiedFields(data, dirtyFields, excluded);
        Object.assign(modifiedData, partialData);

        // Step 2: handle smpl_msgs - UPDATED to send ALL messages without enabled field
        // Step 2: handle smpl_msgs - only if ANY message was actually modified
        if (dirtyFields?.campaign_details?.camp_desc?.smpl_msgs) {
          const sampleMsgsDirty =
            dirtyFields.campaign_details.camp_desc.smpl_msgs;

          // Check if any sample message has any field marked as true
          const hasActualChanges =
            Array.isArray(sampleMsgsDirty) &&
            sampleMsgsDirty.some((msg) => {
              if (typeof msg === "object" && msg !== null) {
                // Check if any property in this message object is true
                return Object.values(msg).some((value) => value === true);
              }
              return false;
            });

          // Only proceed if there are actual changes
          if (hasActualChanges) {
            const currentSamples =
              data.campaign_details.camp_desc.smpl_msgs || [];

            // Format all current samples with sequential IDs only (no enabled field)
            const allFormattedSamples = currentSamples.map((msg, idx) => ({
              id: idx + 1,
              msg_txt: msg.msg_txt || "",
            }));

            // Send ALL sample messages when any change is detected
            if (allFormattedSamples.length > 0) {
              modifiedData.campaign_details = modifiedData.campaign_details || {};
              modifiedData.campaign_details.camp_desc =
                modifiedData.campaign_details.camp_desc || {};
              modifiedData.campaign_details.camp_desc.smpl_msgs =
                allFormattedSamples;
            }
          }
        }

        // Step 3: handle consent_msg (single string)
        if (dirtyFields?.campaign_details?.camp_desc?.consent_msg) {
          const currentConsent = typeof data.campaign_details.camp_desc.consent_msg === "string"
            ? data.campaign_details.camp_desc.consent_msg
            : "";

          if (currentConsent !== SavedConsent) {
            modifiedData.campaign_details = modifiedData.campaign_details || {};
            modifiedData.campaign_details.camp_desc =
              modifiedData.campaign_details.camp_desc || {};
            modifiedData.campaign_details.camp_desc.consent_msg = currentConsent;
          }
        }

        // Step 4: call API only if modified data exists
        if (Object.keys(modifiedData).length > 0) {
          // Step 5: final payload
          const finalPayload = {
            campaign_details: modifiedData.campaign_details || {},
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            brand_id: campInfo.brand_id,
            campaign_id: campInfo.campaignid,
            reqid: 174,
            ...(confirm !== undefined && { req_chk: confirm }),
          };
          try {
            console.log("Final Payload :::::", JSON.stringify(finalPayload));
            setIsloading(true);
            let saverep = await updateSMSCampaigns(finalPayload);
            console.log(
              `reponse of Edit SMS Group :::: ${JSON.stringify(saverep)}`,
            );
            let saverepeMsg = await saverep.json();
            console.log(
              "response of modified data SMS Group  :::" +
              JSON.stringify(saverepeMsg),
            );
            setTimeout(() => {
              setIsloading(false);
            }, 1000);
            if (saverepeMsg.success && saverepeMsg.airesponse?.enable_keys) {
              // Store AI results in state
              setAiResults({
                embedded_link:
                  saverepeMsg.airesponse.enable_keys.embedded_link || false,
                embedded_phnum:
                  saverepeMsg.airesponse.enable_keys.embedded_phnum || false,
                age_gated: saverepeMsg.airesponse.enable_keys.age_gated || false,
              });

              // Open AI Review Summary modal
              setaiReviewSummary(true);
            } else if (saverepeMsg.status && saverepeMsg.status == "success") {
              setRerender(true);
              setSuccessMessage(saverepeMsg.message);
            } else {
              if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                  setError(err.param_name, {
                    type: "server",
                    message: err.message,
                  });
                  const fieldElement = document.querySelector(
                    `input[name="${err.param_name}"]`,
                  );
                  if (fieldElement) {
                    fieldElement.focus();
                    fieldElement.scrollIntoView({ behavior: "smooth" });
                  }
                });
              } else {
                setInternalError(
                  saverepeMsg.message || "Internal Server Error",
                );
              }
            }
          } catch (error) {
            console.error("Save failed :::::", error);
          }
        } else {
          console.log("No changes detected, skipping save.");
        }
      };

  function diffArray(current, saved, idKey, textKey) {
    // Case 1: Deleted → in saved but not in current
    const deleted = saved
      .filter((old) => !current.some((cur) => cur[idKey] === old[idKey]))
      .map((old) => ({ ...old, enabled: false }));

    // Case 2: Added → in current but not in saved
    const added = current
      .filter((cur) => !saved.some((old) => old[idKey] === cur[idKey]))
      .map((cur) => ({ ...cur, enabled: true }));

    // Case 3: Edited → in both, but text changed
    const edited = current
      .filter((cur) => {
        const old = saved.find((old) => old[idKey] === cur[idKey]);
        return old && cur[textKey] !== old[textKey];
      })
      .map((cur) => ({ ...cur, enabled: true }));

    // Final list
    return [...deleted, ...added, ...edited];
  }

  function extractModifiedFields(
    data,
    dirtyFields,
    excludePaths = [],
    parentPath = "",
  ) {
    const modified = {};

    for (const key in dirtyFields) {
      const currentPath = parentPath ? `${parentPath}.${key}` : key;

      // Skip excluded fields like smpl_msgs and consent_msg
      if (excludePaths.includes(currentPath)) {
        continue;
      }

      // Case 1: dirtyFields[key] is a nested object → recurse
      if (
        dirtyFields[key] &&
        typeof dirtyFields[key] === "object" &&
        !Array.isArray(dirtyFields[key])
      ) {
        const nested = extractModifiedFields(
          data[key],
          dirtyFields[key],
          excludePaths,
          currentPath,
        );
        if (Object.keys(nested).length > 0) {
          modified[key] = nested;
        }
      }

      // Case 2: dirtyFields[key] is true → include this field
      else if (dirtyFields[key] === true) {
        modified[key] = data[key];
      }

      // Case 3: dirtyFields[key] === false → skip
    }

    return modified;
  }

  const [basicActive, setBasicActive] = useState("tab1");
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  const showProofTab = campStatus === "CNP Declined" || proofExistFiles.length > 0;

  useEffect(() => {
    if (!showProofTab && basicActive === "tab2") {
      setBasicActive("tab1");
    }
  }, [showProofTab]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Find the specific sticky container
      const stickyParent = document.querySelector(".sticky-top");
      if (!stickyParent) return;

      // Only select .nav-link elements inside that container
      const scrollspyLinks = stickyParent.querySelectorAll(".nav-link");

      // Remove 'active' from all links in the sticky area
      scrollspyLinks.forEach((link) => {
        link.classList.remove("active");
      });

      // Add 'active' only to the first one
      if (scrollspyLinks.length > 0) {
        scrollspyLinks[0].classList.add("active");
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);


  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={270}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/phonenumbers");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/phonenumbers");
                            }}
                          >
                            <strong>Phone System</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/smslanding#tab2");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/smslanding", {
                                state: { tab: "tab2" },
                              });
                            }}
                          >
                            <strong>SMS Registration</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>{campName}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div
                    className={
                      campStatus === "EXPIRED"
                        ? "disabled-form cursor-notAllowed card-body px-0"
                        : "card-body px-0"
                    }
                    {...(campStatus === "EXPIRED" && {
                      title: "This campaign is expired.",
                      onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      },
                    })}
                  >
                    <div className="pb-2">
                      <h5 className="fw-600 mt-2 ">{campName}</h5>
                      <p className="mt-2 text-secondary">
                        {campInfo.apiCampaignId
                          ? `Campaign ID: ${campInfo.apiCampaignId}`
                          : ""}
                      </p>
                      <strong className="mt-3 mb-0">
                        Campaign Status: {campStatus}
                      </strong>
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          General Settings
                        </MDBTabsLink>
                      </MDBTabsItem>
                      {showProofTab && (
                        <MDBTabsItem>
                          <MDBTabsLink
                            onClick={() => handleBasicClick("tab2")}
                            active={basicActive === "tab2"}
                          >
                            Upload Documents
                          </MDBTabsLink>
                        </MDBTabsItem>
                      )}
                    </MDBTabs>


                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <FormProvider {...formMethods}>
                          <MDBRow>
                            <MDBCol md="2">
                              <MDBScrollspy container={containerRef}>
                                <MDBScrollspyLink targetRef={section1}>
                                  Standard Campaign Types
                                </MDBScrollspyLink>

                                <MDBScrollspyLink targetRef={section2}>
                                  Assigned Phone Numbers
                                </MDBScrollspyLink>
                              </MDBScrollspy>
                            </MDBCol>

                            <MDBCol md="8">
                              <div
                                id="element"
                                ref={containerRef}
                                className="scrollspy-example2"
                                style={{ paddingBottom: "6rem" }}
                              >
                                <section ref={section1} id="section-1">
                                  <div class="general-settings" id="general">
                                    Standard Campaign Types
                                  </div>
                                  <CampaignTypes
                                    campaignMiscInfo={campaignMiscInfo}
                                    savedUseCases={savedUseCases}
                                    SavedConsent={SavedConsent}
                                    allLocations={allLocations}
                                    billingGroupList={billingGroupList}
                                    status={campStatus}
                                  />
                                </section>
                                <div className="routing-border mt-2"></div>
                                <section ref={section2} id="section-2">
                                  <CampaignAssignNumbers
                                    setSuccessMessage={setSuccessMessage}
                                    sourceNumber={sourceNumber}
                                    assignedPhoneNumbers={assignedPhoneNumbers}
                                    campaignid={campInfo.campaignid}
                                    brandid={campInfo.brand_id}
                                    setRerender={setRerender}
                                    status={campStatus}
                                    setInternalError={setInternalError}
                                    setIsloading={setIsloading}
                                isCampaignEdit={isCampaignEdit}
                                  />
                                </section>
                                {isSave && (
                                  <SaveChanges
                                    onClose={closeSave}
                                    isdirtyFields={isSave}
                                    onSave={(e) => {
                                      e.preventDefault();
                                      handleSubmit(onSubmit(1))();
                                    }}
                                  />
                                )}
                              </div>
                            </MDBCol>
                          </MDBRow>
                        </FormProvider>

                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === "tab2"}>
                        <MDBRow>
                          <MDBCol md="2">
                            <MDBScrollspy container={containerRef2}>

                              <MDBScrollspyLink targetRef={section3}>
                                Proof of Documents
                              </MDBScrollspyLink>
                            </MDBScrollspy>
                          </MDBCol>

                          <MDBCol md="8">
                            <div
                              id="element"
                              ref={containerRef2}
                              className="scrollspy-example"
                              style={{ paddingBottom: "6rem" }}
                            >
                              <section ref={section3} id="section-3">

                                <CampaignProofDocuments
                                  uploadedExistFiles={proofExistFiles}
                                  campStatus={campStatus}
                                  campaignid={campInfo.apiCampaignId}
                                  setIsloading={setIsloading}
                                  onSave={handleSaveProofDocs}
                                  onCancel={() => {
                                    getSpecificCampaign();
                                  }}
                                />


                              </section>
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                    </MDBTabsContent>


                  </div>
                </div>
              </section>
              {isloading && (
                <>
                  <div className="loadingclass">
                    <MDBBtn disabled>
                      <MDBSpinner
                        size="sm"
                        role="status"
                        tag="span"
                        className="me-2"
                      />
                      Loading...
                    </MDBBtn>
                  </div>
                </>
              )}
            </>
          }
        />
        {successMessage && (
          <>
            <TopSuccess>
              <TopMessage successMessage={successMessage} />
            </TopSuccess>
          </>
        )}

        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}

        <MDBModal
          tabIndex="-1"
          open={aiReviewSummary}
          setOpen={setaiReviewSummary}
          className="ai-review-modal"
        >
          <MDBModalDialog centered size="lg">
            <SampeAIChecksPOPUP
              aiResults={aiResults}
              setAiResults={setAiResults}
              onClose={(e) => {
                // e.preventDefault();
                setaiReviewSummary(false);
              }}
              OnDone={(e) => {
                // e.preventDefault();
                setaiReviewSummary(false);
                setValue(
                  "campaign_details.embed_link",
                  aiResults.embedded_link,
                  { shouldDirty: true },
                );
                setValue(
                  "campaign_details.embed_phno",
                  aiResults.embedded_phnum,
                  { shouldDirty: true },
                );
                setValue("campaign_details.age_content", aiResults.age_gated, {
                  shouldDirty: true,
                });

                handleSubmit(onSubmit(0))();
              }}
            />
          </MDBModalDialog>
        </MDBModal>
        {internalError && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setInternalError("")}
          >
            {internalError ?? "Internal Server Error"}
          </MDBAlert>
        )}
      </>
    </React.Fragment>
  );
}

export default SMSCampaignRegistration;
